import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29c37386"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=29c37386&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c37386')) {
      api.createRecord('29c37386', component.options)
    } else {
      api.reload('29c37386', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29c37386", function () {
      api.rerender('29c37386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/coupon/couponClass/coupon_id/index.vue"
export default component.exports